import React, { Fragment, useEffect, useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import calendarEvent from "./calendarEvent";
import { makeStyles } from "@material-ui/core/styles";
import calendarDayNumberCell from "./calendarDayNumberCell";
import Plus from "../assets/icons/white-plus.png";
import { Link } from "react-router-dom";
import { Box, Button, Typography } from "@material-ui/core";
import { useTranslate } from "react-admin";
import DialogCreateCalendar from "./dialog-create-calendar";
import { useDataProvider } from "react-admin";
import CalendarEventofDay from "./calendarEventOfDay";

const useStyles = makeStyles(theme => ({
    mainDiv: {
        padding: '50px',
        fontStyle: 'bold',
        fontSize: '20px'
    },
    fcView: {
        height: '100%',
        maxHeight: '80vh',
        textAlign: 'center'
    },
    fcDayCell: {
        height: '52.6px !important',
        textAlign: 'center'
    },
    fcDayHeader: {
        borderTop: 'none !important',
    },
    borderCreate: {
        borderRadius: '10px',
        width: '136.9px',
        height: '30px',
        margin: '20px'
    },
    textbtnCreate: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: '0.36px',
        color: '#ffffff',
    }
}));

const MyCalendar = (props: any) => {
    const classes = useStyles();
    const dataProvider = useDataProvider();
    const translate = useTranslate();
    const [openSendAlarm, setOpenSendAlarm] = useState(false);
    const [loading, setLoading] = useState(false);
    const [eventsData, setEventsData] = useState([] as any);
    const [updateCalendarEvents, setUpdateCalendarEvents] = useState(Math.random());
    const [currentState, setCurrentState] = useState(0);
    const [eventOfDay, setEventOfDay] = useState(null as any);

    const mappingEvents = (events: any[]) => {
        let result: any[] = [];
        events.forEach(e => {
            switch (e.interval) {
                case "Daily":
                    mappingDaily(result, e);
                    break;
                case "Weekly":
                    mappingWeekly(result, e);
                    break;
                case "Monthly":
                    mappingMonthly(result, e);
                    break;
                default:
                    result.push(createEventModel(e));
                    break;
            }

        });
        return result;
    }

    const createEventModel = (e: any) => {
        return {
            calendarEventId: e.id,
            title: e.title,
            body: e.body,
            date: e.schedule,
            start: e.schedule,
            type: typeof (e.calendartype) === "string" ? e.calendartype : e.calendartype.type,
            interval: e.interval,
            reminder: e.reminder,
            //end: e.schedule + 30*60*1000,
            ...(typeof (e.calendartype) === "string" ? {} : JSON.parse(e.calendartype?.jsonType))
        }
    }

    const mappingDaily = (result: any[], e: any) => {
        result.push(
            {
                calendarEventId: e.id,
                title: e.title,
                body: e.body,
                //date: e.schedule,
                start: e.schedule,
                end: new Date(e.expiration).getTime(),
                type: typeof (e.calendartype) === "string" ? e.calendartype : e.calendartype.type,
                interval: e.interval,
                reminder: e.reminder,
                ...(typeof (e.calendartype) === "string" ? {} : JSON.parse(e.calendartype?.jsonType))
            }
        );
    }

    const mappingWeekly = (result: any[], e: any) => {
        const expiration = new Date(e.expiration);
        const schedule = new Date(e.schedule);
        const deltaDays = Math.floor((expiration.getTime() - schedule.getTime()) / 24 / 3600 / 1000);
        for (let idx = 0; idx <= deltaDays; idx += 7) {
            const nextSchedule = new Date(e.schedule);
            nextSchedule.setDate(nextSchedule.getDate() + idx);
            if (nextSchedule.getTime() <= expiration.getTime()) {
                const event = { ...e };
                event.schedule = nextSchedule.getTime();
                result.push(createEventModel(event));
            }
        }
    }

    const mappingMonthly = (result: any[], e: any) => {
        const expiration = new Date(e.expiration);
        const schedule = new Date(e.schedule);
        const deltaMonths = (expiration.getFullYear() - schedule.getFullYear()) * 12 + (expiration.getMonth() - schedule.getMonth());
        for (let idx = 0; idx <= deltaMonths; idx++) {
            const nextSchedule = new Date(e.schedule);
            nextSchedule.setMonth(nextSchedule.getMonth() + idx);
            if (nextSchedule.getTime() <= expiration.getTime()) {
                const event = { ...e };
                event.schedule = nextSchedule.getTime();
                result.push(createEventModel(event));
            }
        }
    }

    const getCalendarEvents = () => {
        setLoading(true);
        dataProvider('GET_LIST', "calendar",
            {
                filter: {
                    room: props.roomData?.id || null
                },
                pagination: {},
                sort: { field: 'schedule', order: 'ASC' },
            }).then((res: any) => {
                setLoading(false)
                setEventsData(mappingEvents(res.data));

            }).catch((error: any) => {
                setLoading(false)
            });

    }

    const addCalendarEvent = () => {
        setOpenSendAlarm(true);
    }

    const onCloseDialogCalendar = () => {
        setOpenSendAlarm(false);
    }

    useEffect(() => {
        //load Calendar Event
        getCalendarEvents();
    }, [updateCalendarEvents]);


    const onEventClick = (arg: any) => {
        const eventDef = arg.event._def;
        const eventDataInstance = arg.event._instance;
        console.log('======>', eventDef, eventDataInstance);
        setEventOfDay({
            title: eventDef.title,
            extendedProps: eventDef.extendedProps,
            start: eventDataInstance.range.start,
            end: eventDataInstance.range.end
        })
        setCurrentState(1);
    }


    return <Box className={classes.mainDiv} style={props.mainContainerStyle}>
        {
            currentState === 0 ? (
                <Fragment>
                    <Button
                        variant="contained"
                        color='primary'
                        className={classes.borderCreate}
                        endIcon={<img src={Plus} height={18} style={{ width: "18px" }} />}
                        component={Link}
                        to={{ pathname: '' }}
                        style={{ marginLeft: '16px' }} onClick={addCalendarEvent}
                    >
                        <Typography
                            className={classes.textbtnCreate}
                        >
                            {translate(`pos.calendar.addNewEvent`)}
                        </Typography>
                    </Button>
                    <FullCalendar
                        plugins={[dayGridPlugin]}
                        initialView="dayGridMonth"
                        dayHeaderClassNames={classes.fcDayHeader}
                        viewClassNames={classes.fcView}
                        dayCellClassNames={classes.fcDayCell}
                        dayCellContent={calendarDayNumberCell}
                        events={eventsData}
                        eventContent={calendarEvent}
                        eventClick={onEventClick} timeZone="0"
                    />
                    <DialogCreateCalendar
                        open={openSendAlarm}
                        loadingDialog={loading}
                        onClose={onCloseDialogCalendar}
                        roomData={props.roomData}
                        setUpdateCalendarEvents={setUpdateCalendarEvents}
                    />
                </Fragment>)
                : (
                    <CalendarEventofDay
                        roomData={props.roomData}
                        eventOfDay={eventOfDay}
                        handleBackButton={() => setCurrentState(0)}
                        setUpdateCalendarEvents={setUpdateCalendarEvents}
                    />
                )
        }
    </Box>
};

export default MyCalendar;
